import "./PublishedAndUpdated.scss";
import { HideFor, PenNibIcon, PenNibStraightIcon } from "/App.Components";
import { PublishedAndUpdated as PublishedAndUpdatedProps } from "/Models/Generated/PublishedAndUpdated";
import InfoSmallIcon from "../InfoSmallIcon/InfoSmallIcon";

const PublishedAndUpdated = ({
  publishedLabel,
  publishedDate,
  updatedLabel,
  updatedDate,
}: PublishedAndUpdatedProps) => (
  <div className="published-and-updated-norad">
    <HideFor desktopLargeUp>
      <InfoSmallIcon text={`${publishedLabel} ${publishedDate}`} />
    </HideFor>
    <HideFor mobile tablet desktop desktopMedium>
      <InfoSmallIcon
        icon={PenNibStraightIcon}
        text={`${publishedLabel} ${publishedDate}`}
      />
    </HideFor>
    <HideFor desktopLargeUp>
      <InfoSmallIcon text={`${updatedLabel} ${updatedDate}`} />
    </HideFor>
    <HideFor mobile tablet desktop desktopMedium>
      <InfoSmallIcon
        icon={PenNibIcon}
        text={`${updatedLabel} ${updatedDate}`}
      />
    </HideFor>
  </div>
);

export default PublishedAndUpdated;
